import '../scss/homepage-section-container.scss';

interface Props {
  children: React.ReactNode;
  className?: string;
}

const HomepageSectionContainer: React.FC<Props> = ({ children, className }) => {
  return (
    <section className={`homepage-section-container ${className ?? ''}`}>
      <div className="homepage-section-container__content">{children}</div>
    </section>
  );
};

export default HomepageSectionContainer;

